import type { CourseDetailLocalizedSectionsItemSectionsItemLecturesItem } from './courseDetailLocalizedSectionsItemSectionsItemLecturesItem';

export type CourseDetailLocalizedSectionsItemSectionsItem = {
  /**
   * 섹션 설명
   * @nullable
   */
  description?: string | null;
  /** 섹션 ID */
  id: string;
  /** 섹션에 포함된 강의 목록 */
  lectures: CourseDetailLocalizedSectionsItemSectionsItemLecturesItem[];
  /** 섹션 순서 */
  order: number;
  /** 섹션 제목 */
  title: string;
};
